module.exports = __webpack_public_path__ + "static/media/image_A4.5d083c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog_images/image_A4.png
// module id = 2260
// module chunks = 0